import { PopularDestinations } from 'shared/seo/PopularDestinations';
import hotel from '@/components/internalLinks/hotel.json';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import prepackage from '@/components/internalLinks/prepackage.json';
import { transformDestinations } from '@/components/internalLinks/transformDestinations';
import carRentalData from './data/carrental.json';
import flightData from './data/flight.json';
import { toDestinations } from './toDestinations';

export const HotelSeo = () => {
    const prepackageItems = transformDestinations(prepackage, 'pakkereiser');
    const hotelItems = transformDestinations(hotel, 'hotell');

    const flightCities = toDestinations(flightData.cities, flightData.cdnPath, flightData.basePath, flightData.altPrefix);
    const carRentalCountries = toDestinations(
        carRentalData.countries,
        carRentalData.cdnPath,
        carRentalData.basePath,
        carRentalData.altPrefix,
    );

    return (
        <>
            <InternalLinksSection title="Finn rimelige hoteller i Europa" items={hotelItems} />
            <PopularDestinations heading={flightData.citiesHeading} destinations={flightCities} />
            <InternalLinksSection title="Finn pakkereiser til spennende steder" items={prepackageItems} />
            <PopularDestinations heading={carRentalData.countriesHeading} destinations={carRentalCountries} />
        </>
    );
};
